import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageLoopTest extends PageCommon {
  constructor() {
    super();
  }

  init($data) {
    super.init($data);
      this.showPreloader(false);

      Pqp.trace("PageLoopTest - Hello world");

    let app = document.querySelector(".app");
    let app_dataset = app.dataset.page;
    // page percorso esplora
    if (app_dataset.includes("page-loop")) {
      let btns_filter_entries = ".js-btns-filter-entries";
      if (document.querySelector(btns_filter_entries)) {
       this.initFilterEntries(btns_filter_entries);
      }
    }
    
    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    }
    catch {
      console.error();
    }
  }

  initFilterEntries(btns_wrap) {
    btns_wrap = document.querySelector(btns_wrap);
    let btns = btns_wrap.querySelectorAll(".js-btn-filter-entry");
    let btns_size = btns.length;
    let entries = document.querySelectorAll(".js-entry");
    let entries_size = entries.length;    

    for (let i = 0; i < btns_size; i++) {
      let btn_type = btns[i].dataset.type;            
      btns[i].addEventListener("click", (e) => {
        if (!event.target.classList.contains("is-accent")) {
          for (let j = 0; j < btns_size; j++) {
            btns[j].classList.remove("is-accent");
          }
          event.target.classList.add("is-accent");          
        }        
        // check btn type and show entries accordingly
        if (!(btn_type === "tutte")) {
          for (let j = 0; j < entries_size; j++) {
            let entry_type = entries[j].dataset.type;
            if (entry_type.includes(btn_type)) {
              if (entries[j].classList.contains("is-hidden")) {
                entries[j].classList.remove("is-hidden");
              }
            } else {
              entries[j].classList.add("is-hidden");
            }
          }
        } else {
          for (let j = 0; j < entries_size; j++) {
            if (entries[j].classList.contains("is-hidden")) {
              entries[j].classList.remove("is-hidden");
            }
          }
        }
      });
    }
  }
}